<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="招聘编辑"
    >
        <el-form
            ref="editForm"
            :model="editForm"
            label-width="100px"
            :rules="rules"
        >
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item
                        label="所在部门"
                        size="small"
                        :rules="[{ required: true, message: '请选择所在部门' }]"
                        prop="depart_id"
                    >
                        <selectbutton
                            :props="props"
                            :options="optionData"
                            :value="editForm.depart_id"
                            :clearable="isClearable"
                            :accordion="isAccordion"
                            @getValue="getValue($event)"
                            height="200"
                            ref="selectBtn"
                        ></selectbutton>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="招聘职位"
                        :rules="[{ required: true, message: '请选择招聘职位' }]"
                        prop="role_id"
                        size="small"
                    >
                        <el-select
                            v-model="editForm.role_id"
                            clearable
                            placeholder="请选择招聘职位"
                            size="small"
                        >
                            <el-option
                                v-for="item in roleList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item
                        label="招聘类型"
                        :rules="[{ required: true, message: '请选择招聘类型' }]"
                        prop="type"
                        size="small"
                    >
                        <el-select
                            v-model="editForm.type"
                            clearable
                            placeholder="请选择招聘类型"
                            size="small"
                        >
                            <el-option
                                v-for="item in recruitList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="工作年限"
                        prop="experience"
                        size="small"
                    >
                        <el-input
                            clearable
                            placeholder="请输入工作年限"
                            maxlength="2"
                            size="small"
                            type="number"
                            v-model.number="editForm.experience"
                        >
                            <template slot="append">年</template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item
                        label="招聘人数"
                        prop="people"
                        :rules="[
                            { required: true, message: '招聘人数不能为空' },
                            {pattern:/^[1-9][0-9]*$/,message:'只能输入整数'},
                            {
                                type: 'number',
                                min: 1,
                                message: '招聘人数不能为0',
                            },
                        ]"
                        size="small"
                    >
                        <el-input
                            clearable
                            placeholder="请输入招聘人数"
                            maxlength="5"
                            size="small"
                            type="number"
                            v-model.number="editForm.people"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="到岗日期"
                        prop="req_work_time"
                        :rules="[{ required: true, message: '请选择到岗日期' }]"
                        size="small"
                    >
                        <el-date-picker
                            v-model="editForm.req_work_time"
                            type="date"
                            placeholder="到岗日期"
                            size="small"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item
                        label="职责要求"
                        :rules="[{ required: true, message: '职责要求不能为空' }]"
                        prop="duty"
                        size="small"
                    >
                        <el-input
                            clearable
                            type="textarea"
                            placeholder="请输入职责要求"
                            :autosize="{ minRows: 6, maxRows: 8 }"
                            resize="none"
                            size="small"
                            v-model="editForm.duty"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="任职要求"
                        :rules="[{ required: true, message: '任职要求不能为空' }]"
                        prop="content"
                        size="small"
                    >
                        <el-input
                            clearable
                            type="textarea"
                            placeholder="请输入任职要求"
                            :autosize="{ minRows: 6, maxRows: 8 }"
                            resize="none"
                            size="small"
                            v-model="editForm.content"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="详细说明" size="small">
                        <el-input
                            clearable
                            type="textarea"
                            placeholder="请输入详细说明"
                            :autosize="{ minRows: 6, maxRows: 8 }"
                            resize="none"
                            size="small"
                            v-model="editForm.remark"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24"></el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import * as api from "@/http/api.js";
import selectbutton from "@/comon/components/selectbutton";
import { mapState } from "vuex";
export default {
    data() {
        var setExperience = (rule, value, callback) => {
            setTimeout(() => {
                if (value > 50) {
                    callback(new Error("最大不超过50年"));
                } else if(!/^[1-9][0-9]*$/.test(value)){
                    callback(new Error("只能输入整数"));
                } else {
                    callback();
                }
            }, 100);
        };
        return {
            editForm: {
                experience: 1,
                people: 1,
                role_id: "",
                content: "",
                duty: "",
                type: "",
                people: "",
                experience: "",
                req_work_time: "",
                remark: "",
                depart_id: "",
            },
            roleList: [],
            recruitList: [],
            rules: {
                experience: [
                    { required: true, message: "工作年限不能为空" },
                    { validator: setExperience, trigger: "blur" },
                    { type: "number", min: 1, message: "工作年限不能为0" },
                ],
            },
            isClearable: false, // 可清空（可选）
            isAccordion: true, // 可收起（可选）
            valueId: "", // 初始ID（可选）
            props: {
                // 配置项（必选）
                value: "id",
                label: "name",
                children: "child",
                // disabled: true
            },
            // 选项列表（必选）
            list: [],
            tableItem: {},
        };
    },
    methods: {
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.editForm = {
                experience: 1,
                people: 1,
                role_id: "",
                content: "",
                duty: "",
                type: "",
                people: "",
                experience: "",
                req_work_time: "",
                remark: "",
                depart_id: "",
            };
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            if (this.$refs.selectBtn) {
                this.$refs.selectBtn.clearHandle();
            }
            this.$emit("update:editVisible", false);
        },
        /**
         *  保存
         */
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    oaApi
                        .recruitment(
                            { ...this.editForm },
                            "put",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success("修改成功");
                                this.$parent.recruitment();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        recruitment() {
            oaApi.recruitment({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    this.editForm = res.data;
                }
            });
        },
        getRoleList() {
            oaApi.roleSelect({}, "get").then((res) => {
                if (res) {
                    this.roleList = res.data;
                }
            });
        },
        recruitmentRecruit() {
            oaApi.recruitmentRecruit({}, "get").then((res) => {
                if (res) {
                    this.recruitList = res.data;
                }
            });
        },
        /**
         *  获取组织架构信息
         */
        depart() {
            api.depart({}, "get").then((res) => {
                if (res) {
                    this.list = res.data;
                }
            });
        },
        // 取值
        getValue(value) {
            if (value) {
                this.editForm.depart_id = value.id;
            }
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
    },
    components: {
        selectbutton: selectbutton,
    },
    watch: {
        mixed: {
            handler(newValue) {
                if (newValue.editVisible) {
                    this.tableItem = newValue.tableItem;
                    this.getRoleList();
                    this.recruitmentRecruit();
                    this.depart();
                    this.recruitment();
                }
            },
            deep: true,
            immediate: false,
        },
    },
    computed: {
        ...mapState({
            pickerOptions: (state) => state.index.pickerOptions,
        }),
        /* 转树形数据 */
        optionData() {
            let cloneData = JSON.parse(JSON.stringify(this.list)); // 对源数据深度克隆
            return cloneData.filter((father) => {
                // 循环所有项，并添加children属性
                let branchArr = cloneData.filter(
                    (child) => father.id == child.parent_id
                ); // 返回每一项的子级数组
                branchArr.length > 0 ? (father.child = branchArr) : ""; //给父级添加一个children属性，并赋值
                return father.parent_id == 0; //返回第一层
            });
        },
        mixed() {
            const { tableItem, editVisible } = this;
            return {
                tableItem,
                editVisible,
            };
        },
    },
};
</script>
<style lang="scss">
.edit {
    .el-form-item__content {
        .el-select,
        .el-select--small,
        .el-input--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
}
</style>
